module.exports = __webpack_public_path__ + "assets/support.44d86cd6.svg";